// ---------------------------------------------------------------------------
// sessdbg_role_labels.ts
//
// Stores and provides access to per-user custom role label overrides.
// These are set via /sessdbg by privileged users and are displayed in the
// user profile modal in place of the default role text (Member, Guest, etc.).
//
// Loaded once at app init and updated live by the sessdbg page.
// ---------------------------------------------------------------------------

import * as channel from "./channel.ts";
import * as z from "zod/mini";

const role_labels_response_schema = z.object({
    labels: z.record(z.string(), z.string()),
});

// Map from user_id to override label
const role_label_overrides = new Map<number, string>();

export function get_override(user_id: number): string | undefined {
    return role_label_overrides.get(user_id);
}

export function apply_server_labels(labels: Record<string, string>): void {
    role_label_overrides.clear();
    for (const [user_id_str, label] of Object.entries(labels)) {
        const user_id = Number.parseInt(user_id_str, 10);
        if (label) {
            role_label_overrides.set(user_id, label);
        }
    }
}

export function set_label(user_id: number, label: string): void {
    if (label) {
        role_label_overrides.set(user_id, label);
    } else {
        role_label_overrides.delete(user_id);
    }
}

export function load(): void {
    void channel.get({
        url: "/json/role_label_overrides",
        success(response) {
            const data = role_labels_response_schema.parse(response);
            apply_server_labels(data.labels);
        },
        error() {
            // Non-critical — silently ignore.
        },
    });
}
